export default __webpack_public_path__ + "static/media/Collab11.add9707d.png";